// src/hooks/useComponents.tsx
import { runInAction } from "mobx";
import { observer, useLocalObservable } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var ComponentOverridesContext = React.createContext({});
var ComponentsContext = React.createContext(
  null
);
function useComponents() {
  const components = useContext(ComponentsContext);
  if (components === null)
    throw new Error("useComponents() called outside of ComponentsProvider");
  return components;
}
function useObservableComponents(components) {
  const observableComponents = useLocalObservable(() => components);
  useEffect(() => {
    runInAction(() => {
      observableComponents.Artboard = components.Artboard;
      observableComponents.CompoundPath = components.CompoundPath;
      observableComponents.Container = components.Container;
      observableComponents.Ellipse = components.Ellipse;
      observableComponents.Group = components.Group;
      observableComponents.Head = components.Head;
      observableComponents.Interaction = components.Interaction;
      observableComponents.Mask = components.Mask;
      observableComponents.Node = components.Node;
      observableComponents.NodeList = components.NodeList;
      observableComponents.Path = components.Path;
      observableComponents.Raster = components.Raster;
      observableComponents.Rectangle = components.Rectangle;
      observableComponents.Shape = components.Shape;
      observableComponents.Text = components.Text;
    });
  }, [
    components.Artboard,
    components.CompoundPath,
    components.Container,
    components.Ellipse,
    components.Group,
    components.Head,
    components.Interaction,
    components.Mask,
    components.Node,
    components.NodeList,
    components.Path,
    components.Raster,
    components.Rectangle,
    components.Shape,
    components.Text,
    observableComponents
  ]);
  return observableComponents;
}
var ComponentOverridesProvider = observer(
  function ComponentsOverridesProvider({
    children,
    components = {}
  }) {
    const observableComponents = useObservableComponents(components);
    return /* @__PURE__ */ jsx(ComponentOverridesContext.Provider, { value: observableComponents, children });
  }
);
var ComponentsProvider = observer(function ComponentsProvider2({
  children,
  components
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const componentOverrides = useContext(ComponentOverridesContext);
  const observableComponents = useObservableComponents({
    Artboard: (_a = componentOverrides.Artboard) != null ? _a : components.Artboard,
    CompoundPath: (_b = componentOverrides.CompoundPath) != null ? _b : components.CompoundPath,
    Connector: (_c = componentOverrides.Connector) != null ? _c : components.Connector,
    Container: (_d = componentOverrides.Container) != null ? _d : components.Container,
    Ellipse: (_e = componentOverrides.Ellipse) != null ? _e : components.Ellipse,
    Group: (_f = componentOverrides.Group) != null ? _f : components.Group,
    Head: (_g = componentOverrides.Head) != null ? _g : components.Head,
    Interaction: (_h = componentOverrides.Interaction) != null ? _h : components.Interaction,
    Mask: (_i = componentOverrides.Mask) != null ? _i : components.Mask,
    Node: (_j = componentOverrides.Node) != null ? _j : components.Node,
    NodeList: (_k = componentOverrides.NodeList) != null ? _k : components.NodeList,
    Path: (_l = componentOverrides.Path) != null ? _l : components.Path,
    Raster: (_m = componentOverrides.Raster) != null ? _m : components.Raster,
    Rectangle: (_n = componentOverrides.Rectangle) != null ? _n : components.Rectangle,
    Shape: (_o = componentOverrides.Shape) != null ? _o : components.Shape,
    Text: (_p = componentOverrides.Text) != null ? _p : components.Text
  });
  return /* @__PURE__ */ jsx(ComponentsContext.Provider, { value: observableComponents, children });
});
export {
  ComponentOverridesContext,
  ComponentOverridesProvider,
  ComponentsContext,
  ComponentsProvider,
  useComponents
};
